<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :options="[
        { type: 'date', label: '점검일'},
        { type: 'text', label: '점검장소'},
        { type: 'disaster', label: '재해형태'}
      ]" :board="this.board" :is-print="isPrint"/>

    <!--    장비정보-->
    <table-equipment
      class="mt-5"
      :list="form.equipmentList"
      @updateList="updateList"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
    ></table-equipment>


    <!--    풀베기 작업-->
    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="form.inspectionTitle + ' 작업'"
      :list="form.inspectList"
      @update-list-check="updateListCheck"
    />


    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>

  </div>
</template>

<script>
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TableInspect from '@/components/TableInspect'
import TableEquipment from '@/components/TableEquipment'
import DisasterClassSelector from '@/components/selector/DisasterClassSelector'
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'

export default {
  components: {
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
    PhotoUploadGridModule
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }

        this.form.inspectionTitle = this.inspectionTitle
        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        value.title = value.inputA_2
        this.$emit('input', value)
      }
    }
  },
  data () {
    return {
      inspectionTitle: '풀베기',
      form: {
        inspectionTitle: '풀베기',
        stdInfo: { },
        photoList: [],
        fileList: [],
        equipmentList: [],
        inspectList: []
      },
    }
  },
  computed: {
    inspectTable () {
      return [
        {
          id: 1,
          label: '작업자는 개인보호장구(보안면 등)을 착용하는가?',
          is_checked: ''
        },
        {
          id: 2,
          label: '낫의 상태(날 연마, 날과 몸체 연결부 고정상태)가 양호한가?',
          is_checked: ''
        },
        {
          id: 3,
          label: '낫으로 작업 시 무리한 힘을 가하지 않는가?',
          is_checked: ''
        },
        {
          id: 4,
          label: '예초기 작업 중 예초기 날이 돌 또는 굵은 나무 등에 부딪히지 않도록 주의하는가?',
          is_checked: ''
        },
        {
          id: 5,
          label: '돌 등에 부딪힌 경우에는 엔진을 정지시키고 톱날의 이상 유무를 확인하는가?',
          is_checked: ''
        },
        {
          id: 6,
          label: '예초기를 들고 작업장 이동 시 안전거리(10㎝ 이상) 내에는 다른 작업자의 접근을 금지하는가?',
          is_checked: ''
        },
        {
          id: 7,
          label: '낫을 들고 이동 시 낫 날에 보호덮개를 부착하였는가?',
          is_checked: ''
        },
        {
          id: 8,
          label: '작업 반경(10m 이상) 내에서 다른 작업자의 접근을 금지하는가?',
          is_checked: ''
        },
        {
          id: 9,
          label: '예초기 및 낫날이 넝쿨에 휘감기지 않도록 주의하는가?',
          is_checked: ''
        },
        {
          id: 10,
          label: '넝쿨 위 부분을 1차로 작업한 후 아래 부분을 작업하는가?',
          is_checked: ''
        },
        {
          id: 11,
          label: '작업 방향은 우측에서 좌측으로 실시하는가?',
          is_checked: ''
        },
        {
          id: 12,
          label: '경사 방향으로 작업을 진행하고 급경사지에서는 작업을 금지하고 있는가?',
          is_checked: ''
        },
        {
          id: 13,
          label: '장시간 사용으로 근골격계 질환 발생의 위험은 없는가?',
          is_checked: ''
        },
      ]
    },
  },
  methods : {
    updateList (list) {
      this.form.equipmentList = list
    },
    updateListCheck (indexRows, text) {
      this.form.inspectList[indexRows].is_checked = text
    },
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
